import { BreakpointsOptions } from "@mui/material";

export const BREAKPOINTS_OVERRIDES: BreakpointsOptions = {
  values: {
    xs: 0,
    sm: 660,
    md: 960,
    lg: 1280,
    xl: 1536,
  },
};
